import { BRAND, NAV_LINKS } from "@/data";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="pt-20 pb-10 overflow-hidden"
      style={{ backgroundColor: "var(--mocha-deep)" }}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-12 mb-16">
          <div className="max-w-sm">
            <p className="font-serif text-2xl mb-4" style={{ color: "#FBF6F3" }}>
              ProExec<span style={{ color: "var(--accent-gold)" }}>.</span>
            </p>
            <p
              className="font-serif italic text-lg leading-relaxed"
              style={{ color: "var(--accent-gold-soft)" }}
            >
              {BRAND.slogan}
            </p>
          </div>

          <div className="flex gap-16">
            <div className="flex flex-col gap-3">
              <p className="text-xs tracking-[0.2em] uppercase mb-1" style={{ color: "rgba(251,246,243,0.5)" }}>
                Explore
              </p>
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="link-underline text-sm"
                  style={{ color: "rgba(251,246,243,0.85)" }}
                >
                  {l.label}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-3">
              <p className="text-xs tracking-[0.2em] uppercase mb-1" style={{ color: "rgba(251,246,243,0.5)" }}>
                Get in touch
              </p>
              <a href={`mailto:${BRAND.email}`} className="link-underline text-sm break-all" style={{ color: "rgba(251,246,243,0.85)" }}>
                {BRAND.email}
              </a>
              <span className="text-sm" style={{ color: "rgba(251,246,243,0.85)" }}>{BRAND.phone}</span>
              <span className="text-sm" style={{ color: "rgba(251,246,243,0.85)" }}>{BRAND.location}</span>
            </div>
          </div>
        </div>

        <p
          className="font-serif tracking-tight leading-none text-[16vw] lg:text-[13vw] select-none"
          style={{ color: "rgba(251,246,243,0.06)" }}
        >
          PROEXEC
        </p>

        <div
          className="pt-8 mt-2 flex flex-col md:flex-row md:justify-between gap-3"
          style={{ borderTop: "1px solid rgba(251,246,243,0.12)" }}
        >
          <p className="text-xs" style={{ color: "rgba(251,246,243,0.5)" }}>
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-xs" style={{ color: "rgba(251,246,243,0.5)" }}>
            Virtual Executive Assistant Services · Worldwide
          </p>
        </div>
      </div>
    </footer>
  );
}
